import produce from 'immer'
import { t } from 'helpers/i18n'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import userActions from 'actions/users'
import Component from 'components/CycleCounts/FormView/SelectUser'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(userActions.getOptions({ active: 'Active', ...params })).then((r) =>
        produce(r, (draft) => {
          if (params.pageIndex <= 1 && !params.search) {
            draft.value.data.items.unshift({ id: '', displayName: t('none') })
            draft.value.data.recordCount++
          }
        })
      ),
  }),
})(Component)
